module.exports = __webpack_public_path__ + "img/info.f696b39f.svg";